module.exports = __webpack_public_path__ + "img/img-bc65e7b8.2d148334.png";